import type { HTMLAttributes, ReactNode } from 'react';

export interface DetailListItem {
  label: ReactNode;
  value: ReactNode;
  labelIcon?: ReactNode;
}

export interface DetailListData {
  items: DetailListItem[];
  enableWhatsAppContact?: boolean;
  onWhatsappClick: () => void;
}

export interface DetailListProps extends DetailListData, HTMLAttributes<HTMLDivElement> {
  wrap?: boolean;
  labelClassName?: string;
}
